import "./styles/site.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LangProvider } from "./context/LangContext";
import LandingPage from "./components/site/LandingPage";
import BookPage from "./components/site/BookPage";

function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/book" element={<BookPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
